module.exports = "<span>&copy; {{settings.app.year}} - {{ settings.app.name }}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/dashboard/footer/footer.component.html
// module id = ./src/app/layouts/dashboard/footer/footer.component.html
// module chunks = main